<template>
  <div>
    <ul v-if="disabled" :class="'list-inline ' + listCss">
      <li class="list-inline-item" v-for="item in aToZ" v-bind:key="item.category">
        <a class="text-muted" style="cursor: pointer;" disabled>{{ item.category }}</a>
      </li>
    </ul>
    <ul v-else :class="'list-inline ' + listCss">
      <li class="list-inline-item" v-for="item in aToZ" v-bind:key="item.category">
        <a
            style="cursor: pointer;"
            :style="isSelected(item) ? 'border-bottom: 2px solid #ec9a3c' : ''"
            @click="toggleSelection(item)"
            :class="item.count > 0 ? '' : 'text-muted'"
            :disabled="item.count<=0">
          {{ item.category }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "AToZSelector",
  
  data() {
    return {
      selectedIndex: null
    }
  },

  watch: {
    selected: {
      handler: function (val, oldVal)
      {
        this.selectedIndex = val;
      }
    }
  },

  props: {
    values: Object,
    selected: {
      type: String,
      default: null
    },
    otherLabel: {
      type: String,
      default: "..."
    },
    itemCss: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.selectedIndex = this.selected;
  },

  methods: {
    toggleSelection(item) {
      if (item.count <= 0)
        return;
      
      if (item.code === this.selectedIndex) {
        this.$emit("deselected", item.code);
        this.selectedIndex = null;
      }
      else {
        this.$emit("selected", item.code);
        this.selectedIndex = item.code;
      }
    },

    isSelected(item) {
      return this.selectedIndex === item.code;
    }
  },

  computed: {
    listCss() {
      return this.itemCss == null ? "h3" : this.itemCss;
    },

    aToZ() {
      let list = [];
      for (let i = "A".charCodeAt(0); i <= "Z".charCodeAt(0); i++)
      {
        let item = this.values[String.fromCharCode(i)];
        list.push({
          category: String.fromCharCode(i),
          code: String.fromCharCode(i),
          count: item === undefined ? 0 : item.count
        });
      }
      let item = this.values["..."];
      list.push({
        category: this.otherLabel,
        code: "other",
        count: item === undefined ? 0 : item.count
      });

      return list;
    }
  }
}
</script>